// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  min-height: 200px;
}

.search-container {
  margin-bottom: 10px;
}

.variables-list {
  width: 300px;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
}

.variables-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Create 3 equal columns */
  gap: 10px; /* Adjust the gap between items */
}

.variable-item {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  background-color: #f9f9f9;
  cursor: pointer;
}

@media (max-width: 768px) {
  .variables-grid {
    grid-template-columns: repeat(2, 1fr); /* Switch to 2 columns on smaller screens */
  }
}
@media (max-width: 480px) {
  .variables-grid {
    grid-template-columns: 1fr; /* Switch to 1 column on very small screens */
  }
}
.tab-column {
  background-color: #ffffff; /* Default background color */
  color: black; /* Default text color */
  text-align: left;
  padding-top: 10px;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/features/user-management/users/user-create-or-update/user-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA,EAAA,2BAAA;EACA,SAAA,EAAA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE;IACE,qCAAA,EAGG,2CAAA;EAFL;AACF;AAKA;EACE;IACE,0BAAA,EAAA,6CAAA;EAHF;AACF;AAQA;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EAGA,sCAAA;AARF","sourcesContent":["textarea {\n  min-height: 200px;\n}\n\n.search-container {\n  margin-bottom: 10px;\n}\n\n.variables-list {\n  width: 300px;\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n\n.variables-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* Create 3 equal columns */\n  gap: 10px; /* Adjust the gap between items */\n}\n\n.variable-item {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .variables-grid {\n    grid-template-columns: repeat(\n      2,\n      1fr\n    ); /* Switch to 2 columns on smaller screens */\n  }\n}\n\n@media (max-width: 480px) {\n  .variables-grid {\n    grid-template-columns: 1fr; /* Switch to 1 column on very small screens */\n  }\n}\n\n\n\n.tab-column {\n  background-color: #ffffff; /* Default background color */\n  color: black; /* Default text color */\n  text-align: left;\n  padding-top: 10px;\n  font-size: 1rem;\n  //border: 1px solid rgb(204, 202, 202);\n  //border-radius: 5px;\n  transition: background-color 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
